declare var saveAs: any;

module EEX.McEc.Controls.CertificateDialog {

    import SavePrivateKeyToFileCommand = McEc.Commands.SavePrivateKeyToFileCommand;

    // ReSharper disable once InconsistentNaming
    export interface SavePrivateKeyAttribute extends CertificateDialogBaseAttribute {
    }

    export class SavePrivateKeyModel extends CertificateDialogBaseModel<SavePrivateKeyAttribute> {

        private savePrivateKeyToFileCommand: SavePrivateKeyToFileCommand;

        constructor(model: CertificateDialogModel, processStep: number, savePrivateKeyToFileCommand: SavePrivateKeyToFileCommand) {
            super(model, processStep);
            this.savePrivateKeyToFileCommand = savePrivateKeyToFileCommand;
        }

        public savePrivateKey() {
            const store = this.model.get().store;
            const password = this.model.get().privateKeyPassword;
            const privateKeyFilename = this.getFileName(this.model.get().userInfo);
            this.savePrivateKeyToFileCommand.savePrivateKey(store, password, privateKeyFilename, (store) => this.onSavedFile(store));
        }

        private getFileName(userInfo: AppKitchen.Api.Models.UserInfo): string {
            return `${userInfo.Id}_PrivateKey.pem`;
        }

        private onSavedFile(store: Pki.Store) {
            this.model.set({ store: store });
            this.canContinue();
        }
    }

    // ReSharper disable once InconsistentNaming
    export interface SavePrivateKeyOptions extends CertificateDialogBaseOptions {
    }

    export class SavePrivateKeyView extends CertificateDialogBaseView<SavePrivateKeyModel> {
        model: SavePrivateKeyModel;

        private buttons: {
            save: JQuery,
        }

        constructor(model: SavePrivateKeyModel, target: HTMLElement, options?: SavePrivateKeyOptions) {
            super(model,
                target,
                McEc.Templates.CertificateDialog_SavePrivateKey,
                AppKitchen.OptionsHelper.merge(options,
                    {
                        title: McEc.Strings.CertificateDialog_SavePrivateKey_Title
                    }));
        }

        render() {
            super.render();
            this.setButtons();
            this.setEvents();
            return this;
        }

        private setButtons() {
            this.buttons = {
                save: this.$el.find(".save-private-key-save-btn")
            }
        }

        private setEvents() {
            this.buttons.save.click(() => this.onSave());

            this.buttons.save.focus();
        }

        private onSave() {
            this.model.savePrivateKey();
        }
    }
}